<template>
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.5 7C3.5 6.83333 6.5 7 8.5 5C9.83333 6 13.3 7.4 16.5 5C18.5 7 20.9 7 22.5 7"
      class="stroke-current"
      stroke-width="2"
    />
    <path
      d="M2.5 13C3.5 12.8333 6.5 13 8.5 11C9.83333 12 13.3 13.4 16.5 11C18.5 13 20.9 13 22.5 13"
      class="stroke-current"
      stroke-width="2"
    />
    <path
      d="M2.5 19C3.5 18.8333 6.5 19 8.5 17C9.83333 18 13.3 19.4 16.5 17C18.5 19 20.9 19 22.5 19"
      class="stroke-current"
      stroke-width="2"
    />
  </svg>
</template>
